__turbopack_context__.v({
  "className": "barlow_e9e080dd-module__BmMbCW__className",
});
